export enum ConfirmationClaimType {
  ADD_BENEFICIARY = 'addBeneficiary',
  DELETE_BENEFICIARY = 'deleteBeneficiary',
  UPDATE_BENEFICIARY = 'updateBeneficiary',
  MAKE_PAYMENT = 'makePayment',
  GET_SENSITIVE_CARD_DETAILS = 'getSensitiveCardDetails',
  GET_EPIN = 'getEpin',
  GET_PIN = 'getPin',
  ADD_INTERNATIONAL_BENEFICIARY = 'addInternationalBeneficiary',
  SEND_BULK_PAYMENT = 'sendBulkPayment',
  APPROVE_BULK_PAYMENT = 'approveBulkPayment',
  APPROVE_PAYMENT = 'approvePayment',
  INITIATE_PAYMENT = 'initiatePayment',
  APPROVE_REJECT_PAYMENT = 'approveRejectPayment',
  ADD_CARD = 'addCard',
  ACTIVATE_CARD = 'activateCard',
  /**
   * Cancelling a payment that has not left the platform (reversal window /
   * scheduled) or abandoning a whole bulk-payment run. Its own claim rather
   * than a borrowed `makePayment`, which would demand the payment SCA ceremony
   * to undo a payment. The confirmation SPI accepts any claim string and
   * defaults to all credential types when the realm sets no
   * `cancelpaymentFinxoneConfirmationAllowedTypes` attribute, so no realm
   * seeding is required for this to be mintable.
   */
  CANCEL_PAYMENT = 'cancelPayment',
}
